/**
 * Generates consistent aria-label for answer choice buttons across all test types.
 * Provides natural pause with colon separator for better screen reader UX.
 *
 * @param label - The choice label (e.g., "A", "B", "C", "D", or 1, 2, 3, 4)
 * @param variant - The correctness state in review mode
 * @returns Formatted aria-label string
 *
 * @example
 * getAnswerChoiceAriaLabel("A") → "Answer Choice A:"
 * getAnswerChoiceAriaLabel("B", "correct") → "Answer Choice B: Correct."
 * getAnswerChoiceAriaLabel("C", "incorrect") → "Answer Choice C: Incorrect."
 */
export const getAnswerChoiceAriaLabel = (
  label: string | number,
  variant?: "correct" | "incorrect" | "none"
): string => {
  const baseLabel = `Answer Choice ${label}`

  if (!variant || variant === "none") {
    return `${baseLabel}:`
  }

  const correctnessLabel = variant === "correct" ? "Correct" : "Incorrect"
  return `${baseLabel}: ${correctnessLabel}.`
}
